

/**
 * Filters out any props that should not be passed down as the DOM element's attributes.
 * Returns a config object to be used in the argument of the withConfig function in a styled-component declaration.
 * @example
 * // These props will not be passed down as the DOM element's attributes.
 * // 'color' is a valid DOM attribute, 'focus' is not.
 * const badProps = ['color', 'focus'];
 *
 * const Component = styled.button.withConfig(excludeProps(badProps))`
 *     color: ${({ color }) => color};
 *     outline: ${({ focus }) => focus && '2px solid blue'};
 * `;
 */
export function excludeProps(props) {
  var config = {
    shouldForwardProp: function shouldForwardProp(prop) {return !props.includes(prop);}
  };

  return config;
}
//# sourceMappingURL=excludeProps.js.map